import React from 'react';
import Switch from 'src/shared/components/switch/Switch';

type ShowRevokedToggleProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
};

const ShowRevokedToggle = ({ checked, onChange }: ShowRevokedToggleProps) => {
    return <Switch checked={checked} onChange={onChange} label='Show revoked' />;
};

export default ShowRevokedToggle;
